export const MenuPropsSingle: any = {
  PaperProps: {
    style: {
      maxHeight: '419px',
      overflowY: 'auto',
      maxWidth: '400px',
      minWidth: '280px',
      backgroundColor: 'var(--background-main)',
      borderRadius: '3px',
      zIndex: 3,
    },
  },
  MenuListProps: {
    style: {
      paddingBottom: '1px',
      backgroundColor: 'var(--background-header)',
      '&:hover': {
        backgroundColor: 'var(--background-popupContent)',
        color: 'var(--color)',
      },
      '&:focus': {
        background: 'inherit',
      },
    },
  },
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
  getContentAnchorEl: null,
};

export const MenuPropsSingleSelected = {
  backgroundColor: 'var(--background-main)',
  fontWeight: 'var(--font-weight)',
};
